import { useState } from 'react'
import * as Sentry from '@sentry/react'
import { trackLocationWatchmanSubscribed } from '@/lib/track'
import { loadStoredEmail, saveStoredEmail } from '@/lib/userEmail'
import { markUnitWatched } from '@/features/accommodation/watch-heart/watchedUnits'
import { subscribeLocationWatchman } from './subscribeLocationWatchman'

export type LocationWatchmanStatus = 'idle' | 'submitting' | 'success' | 'error'

interface UseLocationWatchmanForm {
  email: string
  setEmail: (value: string) => void
  status: LocationWatchmanStatus
  submit: (event: React.SubmitEvent<HTMLFormElement>) => void
}

export function useLocationWatchmanForm(slug: string, unitId: number, source: string): UseLocationWatchmanForm {
  const [email, setEmail] = useState(loadStoredEmail)
  const [status, setStatus] = useState<LocationWatchmanStatus>('idle')

  const subscribe = async (): Promise<void> => {
    saveStoredEmail(email)
    setStatus('submitting')
    try {
      await subscribeLocationWatchman(unitId, email)
      markUnitWatched(unitId, email)
      void trackLocationWatchmanSubscribed(slug, unitId, email, source)
      setStatus('success')
    } catch (error) {
      Sentry.captureException(error)
      setStatus('error')
    }
  }

  const submit = (event: React.SubmitEvent<HTMLFormElement>): void => {
    event.preventDefault()
    if (status === 'submitting') return
    // subscribe() handles its own failures, so it never rejects.
    void subscribe()
  }

  return { email, setEmail, status, submit }
}
